// 录音详情
import RecordingDetailsH5 from 'src/pages/external/RecordingDetailsH5';

export const externalRouteNameMappings = {
    externalRecordingDetailsH5: {
        component: RecordingDetailsH5,
    },
};
